import moment from 'moment';
import React, { useEffect, useState } from 'react';

import ParkingsOverviewButton from '@legacy-components/shared/parkings/OverviewButton';

import { useData } from '@shared/api/hooks/useData';
import { CreateParkingRequestButton } from '@shared/parking-requests/components/CreateParkingRequestButton';
import { ParkingRequestsDataTable } from '@shared/parking-requests/components/ParkingRequestsDataTable/ParkingRequestsDataTable';
import { getParkingRequests } from '@shared/parking-requests/endpoints/getParkingRequests';
import { getRegistrationParkings } from '@shared/parking-requests/endpoints/getRegistrationParkings';
import { Alert } from '@shared/ui/components/Alert';
import { Portlet } from '@shared/ui/components/Portlet';

type RegistrationParking = App.Domain.Parking.Data.RegistrationParkingData;
type ParkingRequest = App.Domain.Parking.Data.ParkingRequestData;

export function ListRegistrationParkingRequests({ match }: any) {
  const registrationId = match.params.id;
  const [parkings, setParkings] = useState<RegistrationParking[] | null>(null);

  useEffect(() => {
    getRegistrationParkings(registrationId, { include: ['parking'] }).then((parkings) => {
      setParkings(parkings.data);
    });
  }, [registrationId]);

  const parkingRequests = useData<ParkingRequest>({
    key: 'registration-parkings',
    get: (query) => getParkingRequests(registrationId, query),
    defaults: {
      sort: '-updated_at',
      include: ['parking', 'crew-member.user', 'parking-request-parking-stickers.parkingSticker'],
    },
  });

  return (
    <Portlet
      title="Parking Requests"
      actions={[
        <ParkingsOverviewButton limits={parkings} admin />,
        <CreateParkingRequestButton registrationId={registrationId} />,
      ]}
    >
      {parkings?.length === 0 && (
        <Alert variant="destructive" title="No Registration Parkings" className="mb-8">
          There are no parkings assigned to this registration. Please add at least one parking to the basics tab.
        </Alert>
      )}

      <ParkingRequestsDataTable parkingRequests={parkingRequests} registrationId={registrationId} />
    </Portlet>
  );
}
